export type MediaPopoverContent =
  | MediaVideoPopoverContent
  | MediaImagePopoverContent;

export type MediaVideoPopoverContent = {
  contentType: 'video';
  title: string;
  description: string;
  youtubeVideoUrl?: string;
  videoHeight?: number;
  previewImage?: string;
  media?: string;
  shortcut?: string;
};

export type MediaImagePopoverContent = {
  contentType: 'image';
  title: string;
  description: string;
  image: string;
  shortcut?: string;
};

export enum MediaPopoverContentType {
  Artboard = 'artboard',
  Mockup = 'mockup',
  Export = 'download',
  ColorPalletes = 'recolor',
  Template = 'template',
  Text = 'text',
  KittlAi = 'kittlAi',
  Elements = 'elements',
  Textures = 'texture',
}
